/* unplugin-vue-components disabled */import { render } from "./FeaturedComponent.vue?vue&type=template&id=3f23903d&scoped=true"
import script from "./FeaturedComponent.vue?vue&type=script&lang=js"
export * from "./FeaturedComponent.vue?vue&type=script&lang=js"

import "./FeaturedComponent.vue?vue&type=style&index=0&id=3f23903d&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f23903d"]])

export default __exports__